import script from "./LayoutHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&setup=true&lang=js"

import "./LayoutHeader.vue?vue&type=style&index=0&id=28b12203&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b12203"]])

export default __exports__